import { render, staticRenderFns } from "./versionManagement.vue?vue&type=template&id=47e85a1d&scoped=true&"
import script from "./versionManagement.vue?vue&type=script&lang=js&"
export * from "./versionManagement.vue?vue&type=script&lang=js&"
import style0 from "./versionManagement.vue?vue&type=style&index=0&id=47e85a1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e85a1d",
  null
  
)

export default component.exports